import { getStartTime, getEndTime } from 'find-and-filter-data/search-and-filter-schema/protected';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import { timestampToSimpleDate } from '../operators/dateFilterOperators';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { toMoment } from 'UIComponents/core/SimpleDate';
import { PRESET_DATES } from '../constants/filterConstants';
import { ONE_DAY } from '../../constants/Dates';
import debounce from 'react-utils/debounce';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const debouncedOnChange = debounce((evt, setFilterValues) => {
  const startTime = toMoment(evt.target.value.startDate).valueOf();
  const endTime = toMoment(evt.target.value.endDate).valueOf() + ONE_DAY - 1;
  // -1 here is to make sure we don't show it as second day
  setFilterValues({
    startTimestamp: startTime,
    endTimestamp: endTime
  });
}, 500);
const DateFilter = () => {
  const {
    filterValues,
    setFilterValues
  } = useFilterValues();
  const [displayValue, setDisplayValue] = useState({
    endDate: timestampToSimpleDate(getEndTime(filterValues)),
    startDate: timestampToSimpleDate(getStartTime(filterValues))
  });
  const handleOnChange = evt => {
    setDisplayValue(evt.target.value);
    debouncedOnChange(evt, setFilterValues);
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.date.title"
    }),
    children: /*#__PURE__*/_jsx(UIDateRange, {
      "data-test-id": "date-filter",
      onChange: handleOnChange,
      presets: PRESET_DATES,
      style: {
        display: 'block'
      },
      value: displayValue
    })
  });
};
DateFilter.displayName = 'DateFilter';
export default DateFilter;